import React, { useState } from 'react';
import { Form, Input, Button, Card, message, notification } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined, NumberOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api/auth.service';

const Register: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    if (values.password !== values.password_confirmation) {
      message.error('Lozinke se ne podudaraju');
      return;
    }

    setLoading(true);
    try {
      const result = await authService.register({
        name: values.name,
        email: values.email,
        password: values.password,
        password_confirmation: values.password_confirmation,
        phone: values.phone,
        water_meter_id: values.water_meter_id
      });

      message.success(result.message);
      navigate('/login');
    } catch (error: any) {
      if (error.response?.data?.errors) {
        Object.keys(error.response.data.errors).forEach(key => {
          notification.error({
            message: 'Greška',
            description: error.response.data.errors[key][0]

          
        });
      })
      } else {
        notification.error({
          message: 'Greška',
          description: error.message || 'Došlo je do greške prilikom registracije'
        });
        
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-6">
          <img
            src="/vodovod-doboj-logo.png"
            alt="Vodovod Doboj"
            className="h-14 w-auto max-w-full mx-auto mb-5 object-contain"
          />
          <h2 className="text-2xl font-bold text-gray-900">
            Registracija za Moj Vodovod
          </h2>
          <p className="text-gray-500 mt-2">Unesite šifru vodomjera koja postoji u mreži Vodovoda Doboj</p>
        </div>
        
        <Form
          form={form}
          name="register"
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            name="name"
            rules={[{ required: true, message: 'Unesite vaše ime i prezime' }]}
          >
            <Input 
              prefix={<UserOutlined />}
              placeholder="Ime i prezime"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Unesite email adresu' },
              { type: 'email', message: 'Unesite ispravnu email adresu' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />}
              placeholder="Email adresa"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="phone"
            rules={[{ required: true, message: 'Unesite broj telefona' }]}
          >
            <Input 
              prefix={<PhoneOutlined />}
              placeholder="Broj telefona"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="water_meter_id"
            rules={[{ required: true, message: 'Unesite šifru korisnika / vodomjera' }]}
          >
            <Input 
              prefix={<NumberOutlined />}
              placeholder="Šifra korisnika / vodomjera"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Unesite lozinku' },
              { min: 8, message: 'Lozinka mora imati najmanje 8 karaktera' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Lozinka"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password_confirmation"
            rules={[
              { required: true, message: 'Potvrdite lozinku' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Lozinke se ne podudaraju'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Potvrdite lozinku"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              Registracija
            </Button>
          </Form.Item>

          <div className="text-center">
            <Button type="link" onClick={() => navigate('/login')}>
              Već imate račun? Prijavite se
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Register;
